import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';

const BalanceCard = ({ contract, account }) => {
  const [balance, setBalance] = useState('0');

  useEffect(() => {
    const fetchBalance = async () => {
      if (contract && account) {
        try {
          const balanceResult = await contract.balanceOf(account);
          setBalance(ethers.utils.formatUnits(balanceResult, 18)); // Assuming 18 decimals, adjust if different
        } catch (error) {
          console.error('Error fetching balance:', error);
          setBalance('Error');
        }
      }
    };

    fetchBalance();
  }, [contract, account]);

  return (
    <div className="card balance-card">
      <h2>Your Liquid Scroll Marks Balance</h2>
      <p>{balance} LSM</p>
    </div>
  );
};

export default BalanceCard;